<template>
	<div ref="editorRef" :style="`width: 100%; height: ${height}px; border: #ddd 1px solid`"></div>
</template>

<script lang="ts" name="MaCodeEditor">
import { defineComponent, onMounted, reactive, toRefs, watch } from 'vue'
import ace, { Ace } from 'ace-builds'
import 'ace-builds/src-min-noconflict/mode-json'
import 'ace-builds/src-min-noconflict/mode-html'
import 'ace-builds/src-min-noconflict/mode-sql'
import 'ace-builds/src-min-noconflict/mode-css'
import 'ace-builds/src-min-noconflict/theme-tomorrow'
interface State {
	editorRef?: HTMLElement
	codeEditor?: Ace.Editor
}

export default defineComponent({
	name: 'CodeEditor',
	props: {
		modelValue: {
			type: String,
			default: ''
		},
		height: {
			type: Number,
			default: 400
		},
		language: {
			type: String,
			default: 'html'
		},
		readonly: {
			type: Boolean,
			default: false
		}
	},
	emits: ['update:modelValue'],
	setup(props, context) {
		const state = reactive<State>({
			editorRef: undefined,
			codeEditor: undefined
		})

		onMounted(() => {
			state.codeEditor = ace.edit(state.editorRef!, {
				mode: `ace/mode/${props.language}`,
				theme: 'ace/theme/tomorrow',
				useWorker: false,
				value: props.modelValue,
				readOnly: props.readonly,
				fontSize: 13,
				showPrintMargin: false,
				tabSize: 2
			})

			state.codeEditor.on('change', () => context.emit('update:modelValue', state.codeEditor?.getValue()))
		})

		watch(
			() => props.modelValue,
			val => {
				if (state.codeEditor) {
					const currentPosition = state.codeEditor?.selection.getCursor()
					state.codeEditor.setValue(val)
					state.codeEditor.clearSelection()
					state.codeEditor.gotoLine(currentPosition.row + 1, currentPosition.column, true)
				}
			}
		)

		return {
			...toRefs(state)
		}
	}
})
</script>
